import { ThemeUICSSObject, responsive, spacing } from '@apia/theme';
/* IMPORT HERE */

const taskListColumns: ThemeUICSSObject = {
  '&.modalTaskList': {
    '.tableContainer': {
      display: 'flex',
      justifyContent: 'center',
    },
    table: {
      width: 'auto',
    },

    '.taskListColumnTable': {
      width: '100%',
      overflowX: 'hidden',
      overflowY: 'auto',
      height: '100%',
      maxHeight: '450px',
      thead: {
        zIndex: 300,
      },
    },

    '.dragMode': {
      border: '4px dashed #3191ff',

      '[data-focused="true"]:not(.row__separator__cell):not([data-editionmode="true"]):focus':
        {
          outline: 'none',
        },
    },

    '.draggedCard_container': {
      position: 'relative',
      height: '0px',
    },
    '.draggedCard': {
      border: '2px dashed #3191ff',
      position: 'absolute',
      m: 1,
      zIndex: 101,
      background: 'palette.background.paper',
      left: '30px',
      height: '52px',
      width: '500px',
      p: '14px',
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center',
      boxShadow: 'rgb(0 0 0 / 35%) 0px 5px 15px',
      pointerEvents: 'none',
    },
    '.draggedCard td': { border: 'none' },

    '.draggableRow_notFocus:focus': {
      outline: 'none',
    },
    '.isAbove': { top: '35px' },
    '.isBelow': { top: '-40px' },
    '.dropTargetAbove': {
      position: 'absolute',
      top: responsive({ 1: '-39px', 4: '-38px' }),
      left: '-60px',
      right: '-7px',
      border: '3px dashed #3191ff',
      width: '700px',
    },
    '.dropTargetBelow': {
      position: 'absolute',
      bottom: responsive({ 1: '-34px', 4: '-40px' }),
      left: '-60px',
      right: '-7px',
      border: '3px dashed #3191ff',
      width: '700px',
    },

    'th:first-of-type': {
      width: responsive({ 1: '50px', 3: '100px' }),
      '.headButton:first-of-type': {
        display: 'flex',
        justifyContent: 'center',
        p: responsive({ 1: 2, 3: '0px!important' }),
        width: '100px',
        borderTopRightRadius: '0px',
        borderBottomRightRadius: '0px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
    },
    '.draggableRow': {
      position: 'relative',
      marginBottom: '.4rem',
      backgroundColor: 'palette.background.paper',
      cursor: 'move',
      zIndex: 100,
    },
    '.th__filter': {
      width: responsive({ 1: '45px', 2: '100px' }),
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
    '.td__filter': {
      border: 'none',
    },
    '.td__filter label': {
      margin: 'auto',
      width: 'fit-content',
    },
    'th.th__combo': { width: responsive({ 1: '150px', 3: '220px' }) },
    '.td__combo select': {
      height: '33px',
      p: '0px',
      pl: '11px',
      pr: '20px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    'th:last-of-type': {
      width: '100%',
      '.headButton:last-of-type': {
        width: '100%',
        borderTopLeftRadius: '0px',
        borderBottomLeftRadius: '0px',
      },
    },
    tr: {
      'td:first-of-type': {
        alignItems: 'center',
      },
      'td:nth-last-of-type(2)': {
        display: 'flex',
        justifyContent: 'center',
      },
      'td:last-of-type': {
        display: 'table-cell',
        textAlign: 'center',
        verticalAlign: 'middle',
        div: {
          justifyContent: 'center',
        },
      },
    },
    '.cellContainer': {
      display: 'flex',
      justifyContent: 'start',
    },
    '.cellName': {
      pl: spacing(4),
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    '.dragIcon': {
      flexShrink: 0,
    },

    '.accordion': {
      display: 'flex',
      alignItems: 'center',
      gap: 2,
    },
    '.accordionShow': {
      fontWeight: 'bold',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      gap: 0,
    },
    '.accordionShow__query': {
      display: 'flex',
      flex: 'row',
      alignItems: 'start',
      gap: 2,
    },
    '.accordionFilter': {
      display: 'flex',
      alignItems: 'center',
      gap: 2,
    },
    '.icons__container': {
      display: 'flex',
      flexDirection: 'row',
      gap: 3,
    },
    '.filter__icon': {
      transform: 'scaleX(-1) !important',
    },
    '.td__combo__select': {
      minWidth: '200px',
    },
  },
};

export default taskListColumns;
